export const applyMargins = ({ m, mb, mt, mr, mx, my, ml }) => [
    ...(m ? [`m-${m}`] : []),
    ...(mb ? [`mb-${mb}`] : []),
    ...(mt ? [`mt-${mt}`] : []),
    ...(mr ? [`mr-${mr}`] : []),
    ...(mx ? [`mx-${mx}`] : []),
    ...(my ? [`my-${my}`] : []),
    ...(ml ? [`ml-${ml}`] : []),
];
export const applyPaddings = ({ p, pb, pt, pr, px, py, pl }) => [
    ...(p ? [`p-${p}`] : []),
    ...(pb ? [`pb-${pb}`] : []),
    ...(pt ? [`pt-${pt}`] : []),
    ...(pr ? [`pr-${pr}`] : []),
    ...(px ? [`px-${px}`] : []),
    ...(py ? [`py-${py}`] : []),
    ...(pl ? [`pl-${pl}`] : []),
];
export const applySpacings = (props) => [...applyMargins(props), ...applyPaddings(props)];
